import { defineStore, storeToRefs } from "pinia";
import { ref } from 'vue';
import axios from "axios";
import { useCabinetStore } from "@/stores/cabinetStore.js";

export const useHeaderStore = defineStore('header-store',  () => {
  const recentCabinetList = ref([])

  function getRecentCabinetList() {
    // TODO: in the future, this should only pull the 5 most recently visited cabinets
    axios.get(`/api/cabinets`).then(r => recentCabinetList.value = r.data.slice(0, 5)) // return the first 5 cabinets (not most recent yet)
  }

  const notifications = ref([])

  function getNotifications() {
    axios.get(`/api/user_notifications`).then(r => { notifications.value = r.data })
  }

  function hideNotification(notificationId) {
    axios.post(`/api/user_notifications/${notificationId}/read`).then(() => {
      // Update local state to reflect the change immediately
      const notification = notifications.value.find(n => n.un_id === notificationId)
      if (notification)
        notification.viewed = true
    })
  }

  const drawerCollapseStates = ref({ left: false, right: false })

  const cabinetStore = useCabinetStore()
  const { cabinetData } = storeToRefs(cabinetStore)

  return {
    recentCabinetList,
    getNotifications,
    hideNotification,
    notifications,
    drawerCollapseStates,
    cabinetData,
    getRecentCabinetList
  }
})
